<router-outlet></router-outlet>
<div class="build-footer">{{display_version}}</div>